// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SubReportGrid.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * SubReportGrid Component
 */
import React from 'react';
import { observer } from 'mobx-react';
import PropertiesBuilderConstants from 'logic/data/Izenda.PropertiesBuilderConstants';
import Validator from 'share/components/hoc/Izenda.Validator';
import DropDown from 'share/components/controls/Izenda.DropDown';
import { Table, Column } from 'share/components/controls/DataGrid/Izenda.Table';
import { compact } from 'lodash/fp';
const constants = PropertiesBuilderConstants.SUB_REPORT;
const ValidatableDropDown = Validator()(DropDown);

@observer
class SubReportGrid extends React.Component {
  static displayName = 'SubReportGrid';

  groupFormatText(text: Object) {
    return `${text.connectionName}.${text.querySourceCategoryName}.${text.sourceDataObjectName}`;
  }

  renderFieldInSubReport = (fieldItem: Object, key: String, rowIndex: Number) => {
    function changeField(object, field) {
      fieldItem.fieldInSubReport = field.querySourceFieldId;
      fieldItem.relationshipInSubReport = field.relationshipId;
      fieldItem.fieldNameInSubReport = field.fieldNameInSubReport;
    }
    let options = this.props.model.fieldInSubReport;
    let value = compact([fieldItem.relationshipInSubReport, fieldItem.fieldInSubReport]).join('_');

    return options.length !== 0 ? (
      <ValidatableDropDown
        options={options}
        onChange={changeField}
        value={value}
        labelField="sourceFieldName"
        valueField="id"
        groupBy="sourceDataObjectName"
        blankOption
        groupFormatText={this.groupFormatText}
        validations={constants.CONSTRAINTS.REQUIRED_CONSTRAINT}
        field={'fieldInSubReport'}
        group={constants.SUB_REPORT_GRID.VALIDATOR_GROUP + rowIndex}
      />
    ) : null;
  };

  renderFieldInCurrentReportPart = (fieldItem: Object, key: String, rowIndex: Number) => {
    function changeField(object) {
      fieldItem.fieldNameAlias = object.value;
    }
    let options = this.props.model.fieldInCurrentReportPart;

    return options.length !== 0 ? (
      <ValidatableDropDown
        options={options}
        onChange={changeField}
        value={fieldItem.fieldNameAlias}
        labelField="name"
        valueField="name"
        blankOption
        groupFormatText={this.groupFormatText}
        validations={constants.CONSTRAINTS.REQUIRED_CONSTRAINT}
        field={'fieldInCurrentReportPart'}
        group={constants.SUB_REPORT_GRID.VALIDATOR_GROUP + rowIndex}
      />
    ) : null;
  };

  renderDeleteField = (fieldItem: Object, key: String, rowIndex: Number) => {
    function deleteField() {
      this.props.model.removeMappingField(rowIndex);
    }
    return (
      <a onClick={deleteField.bind(this)}>
        <span className="icon-cancel" />
      </a>
    );
  };

  render() {
    const TABLE_DEF = constants.TABLE_DEF;

    return (
      <Table dataSource={this.props.model.gridData}>
        <Column {...TABLE_DEF.fieldInCurrentReport} cell={this.renderFieldInCurrentReportPart} />

        <Column {...TABLE_DEF.fieldInSubReport} cell={this.renderFieldInSubReport} />

        <Column {...TABLE_DEF.deleteField} cell={this.renderDeleteField} />
      </Table>
    );
  }
}

export default SubReportGrid;



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.SubReportGrid.js